// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Affiche QR d'un lieu : à l'impression, seule la feuille sort. Le menu, la
 * barre du haut, le formulaire de configuration et les boutons de l'affiche
 * restent à l'écran.
 *
 * \`visibility\` plutôt que \`display\` : l'affiche est un descendant de la page,
 * et un ancêtre en \`display: none\` l'emporterait avec lui.
 *
 * Le voile reste en \`position: fixed\`, comme à l'écran : c'est ce qui ancre
 * l'affiche en haut de la page imprimée, où que la RH ait fait défiler
 * l'écran de configuration derrière. Repositionner la feuille en \`absolute\`
 * la plaçait par rapport à un ancêtre défilé, et le haut de l'affiche sortait
 * de la page.
 */
@media print {
  body * {
    visibility: hidden;
  }

  .affiche-qr-feuille,
  .affiche-qr-feuille * {
    visibility: visible;
  }

  .affiche-qr {
    position: fixed;
    inset: 0;
    display: block;
    overflow: visible;
    background: #ffffff;
    padding: 0;
  }

  .affiche-qr-cadre {
    max-width: none;
    padding: 15mm 0 0;
    border-radius: 0;
    box-shadow: none;
  }

  .affiche-qr-code {
    width: 120mm;
  }

  .affiche-qr-hors-impression {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Pointage/AfficheQrLieu.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE;AACF;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/*\n * Affiche QR d'un lieu : à l'impression, seule la feuille sort. Le menu, la\n * barre du haut, le formulaire de configuration et les boutons de l'affiche\n * restent à l'écran.\n *\n * `visibility` plutôt que `display` : l'affiche est un descendant de la page,\n * et un ancêtre en `display: none` l'emporterait avec lui.\n *\n * Le voile reste en `position: fixed`, comme à l'écran : c'est ce qui ancre\n * l'affiche en haut de la page imprimée, où que la RH ait fait défiler\n * l'écran de configuration derrière. Repositionner la feuille en `absolute`\n * la plaçait par rapport à un ancêtre défilé, et le haut de l'affiche sortait\n * de la page.\n */\n@media print {\n  body * {\n    visibility: hidden;\n  }\n\n  .affiche-qr-feuille,\n  .affiche-qr-feuille * {\n    visibility: visible;\n  }\n\n  .affiche-qr {\n    position: fixed;\n    inset: 0;\n    display: block;\n    overflow: visible;\n    background: #ffffff;\n    padding: 0;\n  }\n\n  .affiche-qr-cadre {\n    max-width: none;\n    padding: 15mm 0 0;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .affiche-qr-code {\n    width: 120mm;\n  }\n\n  .affiche-qr-hors-impression {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
